export default __webpack_public_path__ + "static/media/carousel_2_768.43126bf2.webp";